import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpService, HttpRequestModel } from 'src/app/service/httpservice/http.service';
import { ToolSearchParams } from 'src/app/shared/models/toolSearchParams';
import { buildQueryString } from 'src/app/utils/functions';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';
@Injectable({
  providedIn: 'root',
})
export class ToolSettingsService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(
    private httpService: HttpService,
    private authService: AuthService,
  ) { }

  private defaultParams: ToolSearchParams = {
    page: 1,
    limit: 1000,
    search: '',
    fields: '',
    order: 'toolId,DESC',
    hub_access: 'true',
  };

  private defaultUserParams: ToolSearchParams = {
    search: '',
    page: 1,
    limit: 1000,
    attributes: 'id,firstName,lastName,employeeAlias',
    'scope[status]': 1,
    order: 'employeeAlias,ASC',
  };

  defaultShopParams: ToolSearchParams = {
    page: 1,
    limit: 1000,
    search: '',
    fields: '',
  };

  private activeEmployees = {
    order: 'employee_alias ASC', // this format is not wrong, it is using v1 endpoints
    status: '1',
  };

  private embedAssignment: {
    attributes: 'type.name';
    embed: 'responsibleParty,employee,foreman,owner,facility,vendor,department';
  };

  private dataParams: ToolSearchParams = {
    ...this.defaultParams,
    order: 'name,asc',
  };

  private enableDataParams: ToolSearchParams = {
    ...this.defaultParams,
    // search: 1,
    // fields: 'enabled',
    order: 'name,asc',
  };

  private enabledFilterParams: ToolSearchParams = {
    ...this.enableDataParams,
    filter: 'enabled=1'
  }

  private embedAssetClass = {
    embed: 'assetClass',
  };

  private jobParams = {
    attributes: 'jobNumber,name',
    order: 'name,ASC',
  };

  private assignmentParams = {
    embed: 'responsibleParty,employee,owner,job,facility,vendor,department,type',
  };
  private batchIdParams = {
    attributes: ['batchId'],
    group: ['batchId'],
    order: ['batchId', 'DESC'],
  };

  private assignmentFilterParams = {
    limit: 100000,
    embed: 'assignment',
  };

  // READ endpoints
  // READ endpoints should accept ToolSearchParams as input. This input should override a set of defaults assigned to the GET endpoint
  read = {
    departments: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `departments`, { ...params }),
    employees: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `users/v2`, {
        ...this.defaultUserParams,
        ...params,
      }),
    'asset-classes': (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/assets_classes`, {
        ...this.enabledFilterParams,
        ...params
      }),
    manufacturers: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/manufacturers`, {
        ...this.enabledFilterParams,
        ...params,
      }),
    categories: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/categories`, {
        ...this.enabledFilterParams,
        ...this.embedAssetClass,
        ...params,
      }),
    'categories-assetclass': (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/categories`, {
        ...this.enableDataParams,
        ...params,
      }),
    'shop-locations': (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `shop_locations`, {
        ...this.defaultShopParams,
        ...params,
      }),
    assignment_types: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/assignment_types`, {
        ...this.dataParams,
        ...params,
      }),
    jobs: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `jobs/v2`, { ...this.jobParams, ...params }),
    owner: (params: ToolSearchParams = {}): Observable<any> => this.postRequest('GET', `owner`, { ...params }),
    vendors: (params: ToolSearchParams = {}): Observable<any> => this.postRequest('GET', `vendors`, { ...params }),
    assignmentFilters: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/history/assignments`, {
        ...this.assignmentFilterParams,
        ...params,
      }),
    assignmentFiltersNames: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/history/assignmentNames`, {
        ...this.assignmentFilterParams,
        ...params,
      }),
    batchId: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/assignments`, {
        ...this.batchIdParams,
        ...params,
      }),
    assignment: (id, params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/assignments/${id}`, {
        ...this.assignmentParams,
        ...params,
      }),
    tools: (params: ToolSearchParams = this.defaultParams): Observable<any> =>
      this.postRequest('GET', `tools`, { ...this.defaultParams, ...params }),

     inventory: (params: ToolSearchParams = {}): Observable<any> =>
      this.postRequest('GET', `tools/inventory`, {
        ...this.defaultParams,
        ...params,
      }),

    // Inventory Table filter dropdowns
      inventoryTools: (params: ToolSearchParams = this.defaultParams): Observable<any> =>
      this.postRequest('GET', `tools/inventory`, {
        ...params,
        'scope[inventory-toolId]': '',
        'scope[inventory]': 1
      }),

      inventoryCategories: (params: ToolSearchParams = this.defaultParams): Observable<any> =>
        this.postRequest('GET', `tools/inventory`, {
          ...params,
          'scope[inventory-category]': '',
          'scope[inventory]': 1
        }),

      inventoryResponsibleParties: (params: ToolSearchParams = this.defaultParams): Observable<any> =>
      this.postRequest('GET', `tools/inventory`, {
        ...params,
        'scope[inventory-responsibleParty]': '',
        'scope[inventory]': 1
      }),

    inventoryInventoriedBy: (params: ToolSearchParams = this.defaultParams): Observable<any> =>
      this.postRequest('GET', `tools/inventory`, {
        ...params,
        'scope[inventory-inventoriedBy]': '',
        'scope[inventory]': 1
      }),

    inventoryBatchNumbers: (params: ToolSearchParams = this.defaultParams): Observable<any> =>
      this.postRequest('GET', `tools/inventory`, {
       ...params,
        'scope[inventory-inventoryBatchNumber]': '',
        'scope[inventory]': 1
      }),

    inventoryAssignedTo: (params: ToolSearchParams = this.defaultParams): Observable<any> =>
      this.postRequest('GET', `tools/inventory`, {
        ...params,
        'scope[inventory-assignedTo]': '',
        'scope[inventory]': 1
      }),

  };

  // CREATE endpoints
  create = {
    'asset-classes': (payload: any = {}): Observable<any> => this.postRequest('POST', `tools/assets_classes`, payload),
    manufacturers: (payload: any = {}): Observable<any> => this.postRequest('POST', `tools/manufacturers`, payload),
    categories: (payload: any = {}): Observable<any> => this.postRequest('POST', `tools/categories`, payload),
    'shop-locations': (payload: any = {}): Observable<any> => this.postRequest('POST', `shop_locations`, payload),
    alert: (payload: any = {}): Observable<any> => this.postRequest('POST', `tools/alerts`, payload),
    vehicle_details: (payload: any = {}): Observable<any> => this.postRequest('POST', `tools/vehicle_details`, payload),
  };

  // UPDATE endpoints
  update = {
    'asset-classes': (payload: any = {}): Observable<any> =>
      this.postRequest('PUT', `tools/assets_classes/${payload.id}`, payload.data),
    manufacturers: (payload: any = {}): Observable<any> =>
      this.postRequest('PUT', `tools/manufacturers/${payload.id}`, payload.data),
    categories: (payload: any = {}): Observable<any> =>
      this.postRequest('PUT', `tools/categories/${payload.id}`, payload.data),
    'shop-locations': (payload: any = {}): Observable<any> =>
      this.postRequest('PUT', `shop_locations/${payload.id}`, payload.data),
    alert: (payload: any = {}): Observable<any> => this.postRequest('PUT', `tools/alerts/${payload.id}`, payload.data),
    vehicle_details: (payload: any = {}, id: string): Observable<any> =>
      this.postRequest('PUT', `tools/vehicle_details/${id}`, payload),
  };

  // ENABLE/DISABLE asset_class
  status = {
    'asset-classes': (payload: any): Observable<any> =>
      this.postRequest('PATCH', `tools/assets_classes/${payload.id}`, {
        enabled: payload.data.enabled,
      }),
    manufacturers: (payload: any): Observable<any> =>
      this.postRequest('PATCH', `tools/manufacturers/${payload.id}`, {
        enabled: payload.data.enabled,
      }),
    categories: (payload: any): Observable<any> =>
      this.postRequest('PATCH', `tools/categories/${payload.id}`, {
        enabled: payload.data.enabled,
      }),
    'shop-locations': (payload: any): Observable<any> =>
      this.postRequest('PATCH', `shop_locations/${payload.id}`, {
        enabled: payload.data.enabled,
      }),
  };

  // DELETE endpoints
  delete = {
    'asset-classes': (id: number): Observable<any> => this.postRequest('DELETE', `tools/assets_classes/${id}`),
    manufacturers: (id: number): Observable<any> => this.postRequest('DELETE', `tools/manufacturers/${id}`),
    categories: (id: number): Observable<any> => this.postRequest('DELETE', `tools/categories/${id}`),
    'shop-locations': (id: number): Observable<any> => this.postRequest('DELETE', `shop_locations/${id}`),
  };

  private postRequest(
    requestType: string,
    url: string,
    data: any = '',
    showLoader: boolean = false,
    hideLoader: boolean = false,
  ): Observable<any> {
    // if GET request and param data was received, format query string and reset data to be sent in body
    if (requestType === 'GET' && data) {
      const queryString = buildQueryString(data);
      url += queryString;
      data = '';
    }

    this.HttpRequestModel.reset();
    this.HttpRequestModel.method = requestType;
    this.HttpRequestModel.url = url;
    this.HttpRequestModel.body = data;
    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
